import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-footer" }
const _hoisted_2 = { class: "terms-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agree_modal_comp = _resolveComponent("agree-modal-comp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('footer.info')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", {
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTerms('IndvTerms')))
      }, _toDisplayString(_ctx.$t('footer.indv')), 1),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("span", {
        class: "cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTerms('MooveTerms')))
      }, _toDisplayString(_ctx.$t('footer.service')), 1)
    ]),
    _createVNode(_component_agree_modal_comp, {
      visible: _ctx.termsVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.termsVisible) = $event)),
      mode: "confirm"
    }, {
      content: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.terms)))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}